/* OSMANLI DEĞERLİ TAŞ — koyu tasarım ortak davranışlar (odt-dark)
   header · hero · kart rayı · fanlı karusel · mozaik · yorum şeridi · sepete ekle · favori · video modal */
(function () {
  'use strict';
  var D = document, W = window;
  function $(s, c) { return (c || D).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || D).querySelectorAll(s)); }
  function on(el, ev, fn, o) { if (el) el.addEventListener(ev, fn, o || false); }

  /* ---------- toast ---------- */
  var toastEl, toastT;
  function toast(html, ms) {
    if (!toastEl) { toastEl = D.createElement('div'); toastEl.className = 'odt-toast'; D.body.appendChild(toastEl); }
    toastEl.innerHTML = html; toastEl.classList.add('is-on'); clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, ms || 3500);
  }

  /* ---------- sepet ---------- */
  function setCartCount(n) { $$('[data-odt-cart-count]').forEach(function (b) { b.textContent = n; b.classList.toggle('is-zero', !n); }); }
  function refreshCart() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (c) { setCartCount(c.item_count); }).catch(function () {});
  }
  function addToCart(id, btn) {
    if (!id) return;
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'EKLENİYOR…'; }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Hata'); return j; }); })
      .then(function () {
        refreshCart(); toast('Ürün sepete eklendi <a href="/cart">Sepete git</a>');
        if (btn) { btn.textContent = 'EKLENDİ ✓'; setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1800); }
      })
      .catch(function (e) { toast(String(e.message || 'Sepete eklenemedi').replace(/[<>&]/g, '')); if (btn) { btn.textContent = label; btn.disabled = false; } });
  }
  on(D, 'click', function (e) {
    var b = e.target.closest('[data-odt-atc]'); if (!b) return;
    e.preventDefault(); addToCart(b.getAttribute('data-odt-atc'), b);
  });

  /* ---------- favori (Osmanlı Yönetim Paneli entegrasyonu) ---------- */
  on(D, 'click', function (e) {
    var b = e.target.closest('[data-odt-fav]'); if (!b) return; e.preventDefault();
    var cfg = W.ODT_CFG;
    if (!cfg || !cfg.customer) { W.location.href = (cfg && cfg.loginUrl) || '/account/login'; return; }
    var p = {}; try { p = JSON.parse(b.getAttribute('data-odt-fav')); } catch (x) {}
    b.disabled = true;
    fetch(cfg.api + '/favorite/toggle', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ store: cfg.store, customer_id: cfg.customer.id, customer_email: cfg.customer.email, customer_name: cfg.customer.name, product_id: p.id, product_handle: p.handle, product_title: p.title, product_image: p.image }) })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        b.classList.toggle('is-active', !!d.favorited); toast(d.favorited ? 'Favorilere eklendi' : 'Favorilerden çıkarıldı');
        var c = $('#odt-fav-icon .odt-hcount'); if (c && typeof d.count === 'number') { c.textContent = d.count; c.style.display = d.count ? '' : 'none'; }
      })
      .catch(function () { toast('Bir hata oluştu, lütfen tekrar deneyin.'); })
      .then(function () { b.disabled = false; });
  });

  /* ---------- video modal ---------- */
  var modal;
  function openVideo(src, wide) {
    if (!modal) {
      modal = D.createElement('div'); modal.className = 'odt-modal';
      modal.innerHTML = '<div class="odt-modal__box"><button class="odt-modal__close" aria-label="Kapat">✕</button><div class="odt-modal__body"></div></div>';
      D.body.appendChild(modal);
      on(modal, 'click', function (e) { if (e.target === modal || e.target.closest('.odt-modal__close')) closeVideo(); });
      on(D, 'keydown', function (e) { if (e.key === 'Escape') closeVideo(); });
    }
    var box = $('.odt-modal__box', modal), body = $('.odt-modal__body', modal);
    box.classList.toggle('is-wide', !!wide);
    var yt = src.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{6,})/);
    var vm = src.match(/vimeo\.com\/(\d+)/);
    if (yt) body.innerHTML = '<iframe src="https://www.youtube.com/embed/' + yt[1] + '?autoplay=1&rel=0&playsinline=1" allow="autoplay; fullscreen" allowfullscreen></iframe>';
    else if (vm) body.innerHTML = '<iframe src="https://player.vimeo.com/video/' + vm[1] + '?autoplay=1" allow="autoplay; fullscreen" allowfullscreen></iframe>';
    else body.innerHTML = '<video src="' + src + '" controls autoplay playsinline></video>';
    modal.classList.add('is-open'); D.body.style.overflow = 'hidden';
  }
  function closeVideo() { if (!modal) return; modal.classList.remove('is-open'); $('.odt-modal__body', modal).innerHTML = ''; D.body.style.overflow = ''; }
  on(D, 'click', function (e) {
    var b = e.target.closest('[data-odt-video]'); if (!b) return; e.preventDefault();
    var s = b.getAttribute('data-odt-video'); if (s) openVideo(s, b.hasAttribute('data-odt-video-wide')); else toast('Video henüz eklenmedi.');
  });

  /* ---------- header ---------- */
  function initHeader(h) {
    if (h.__odt) return; h.__odt = 1;
    function sc() { h.classList.toggle('is-scrolled', W.scrollY > 30); }
    on(W, 'scroll', sc, { passive: true }); sc();
    var burger = $('[data-odt-burger]', h), close = $('[data-odt-mclose]', h);
    function open() { h.classList.add('is-menu-open'); D.body.style.overflow = 'hidden'; }
    function shut() { h.classList.remove('is-menu-open'); D.body.style.overflow = ''; }
    on(burger, 'click', open); on(close, 'click', shut);
    $$('[data-odt-macc]', h).forEach(function (b) { on(b, 'click', function () { b.closest('li').classList.toggle('is-open'); }); });
    $$('.odt-nav__item.has-sub', h).forEach(function (li) {
      var a = $('a', li);
      on(a, 'click', function (e) { if (W.matchMedia('(hover:none)').matches && !li.classList.contains('is-open')) { e.preventDefault(); li.classList.add('is-open'); } });
      on(D, 'click', function (e) { if (!li.contains(e.target)) li.classList.remove('is-open'); });
    });
  }

  /* ---------- hero slayt ---------- */
  function initHero(root) {
    if (root.__odt) return; root.__odt = 1;
    var slides = $$('.odt-hero__slide', root), i = 0, n = slides.length, t, auto = Number(root.getAttribute('data-autoplay') || 0);
    if (n < 2) { $$('.odt-arrow', root).forEach(function (b) { b.setAttribute('disabled', ''); }); if (n === 1) { $$('.odt-hero__video', slides[0]).forEach(function (v) { if (!v.getAttribute('src')) v.setAttribute('src', v.getAttribute('data-src') || ''); var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }); } return; }
    function vids(s) { return $$('.odt-hero__video', s); }
    function playSlide(s) { vids(s).forEach(function (v) { if (!v.getAttribute('src')) v.setAttribute('src', v.getAttribute('data-src') || ''); if (getComputedStyle(v).display !== 'none') { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); } }); }
    function stopSlide(s) { vids(s).forEach(function (v) { try { v.pause(); } catch (e) {} }); }
    function go(k) { stopSlide(slides[i]); slides[i].classList.remove('is-active'); i = (k + n) % n; slides[i].classList.add('is-active'); playSlide(slides[i]); }
    playSlide(slides[0]);
    function next() { go(i + 1); } function prev() { go(i - 1); }
    function restart() { clearInterval(t); if (auto > 0) t = setInterval(next, auto * 1000); }
    on($('[data-odt-next]', root), 'click', function () { next(); restart(); });
    on($('[data-odt-prev]', root), 'click', function () { prev(); restart(); });
    var x0 = null;
    on(root, 'pointerdown', function (e) { if (e.target.closest('.odt-arrow')) return; x0 = e.clientX; });
    on(root, 'pointerup', function (e) { if (x0 === null) return; var dx = e.clientX - x0; x0 = null; if (Math.abs(dx) > 50) { dx < 0 ? next() : prev(); restart(); } });
    restart();
  }

  /* ---------- kart rayı (ürün karuseli) ---------- */
  function initTrack(root) {
    if (root.__odt) return; root.__odt = 1;
    var track = $('.odt-track', root), dots = $('.odt-dots', root), prev = $('[data-odt-prev]', root), next = $('[data-odt-next]', root);
    if (!track) return;
    function pages() { return Math.max(1, Math.ceil(track.scrollWidth / track.clientWidth - 0.02)); }
    function cur() { return Math.round(track.scrollLeft / track.clientWidth); }
    function render() {
      var p = pages(), c = cur();
      if (dots) {
        dots.innerHTML = '';
        for (var k = 0; k < p; k++) {
          var b = D.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', (k + 1) + '. sayfa');
          if (k === c) b.className = 'is-active';
          (function (k) { on(b, 'click', function () { track.scrollTo({ left: k * track.clientWidth, behavior: 'smooth' }); }); })(k);
          dots.appendChild(b);
        }
      }
      if (prev) prev.toggleAttribute('disabled', c <= 0);
      if (next) next.toggleAttribute('disabled', c >= p - 1);
    }
    on(prev, 'click', function () { track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' }); });
    on(next, 'click', function () { track.scrollBy({ left: track.clientWidth, behavior: 'smooth' }); });
    var st; on(track, 'scroll', function () { clearTimeout(st); st = setTimeout(render, 80); }, { passive: true });
    on(W, 'resize', render); render();
  }

  /* ---------- fanlı karusel ---------- */
  function initFan(root) {
    if (root.__odt) return; root.__odt = 1;
    var stage = $('.odt-fan__stage', root), cards = $$('.odt-fan__card', root), n = cards.length;
    var i = Math.floor(n / 2), auto = Number(root.getAttribute('data-autoplay') || 0), t;
    if (!n) return;
    function layout() {
      var w = stage.clientWidth, step = Math.min(250, Math.max(110, w * 0.19));
      cards.forEach(function (c, k) {
        var off = k - i; if (off > n / 2) off -= n; if (off < -n / 2) off += n;
        var a = Math.abs(off), s = Math.max(.58, 1 - .13 * a), o = a > 2 ? 0 : 1 - .15 * a;
        c.style.transform = 'translate(-50%,-50%) translateX(' + (off * step) + 'px) scale(' + s + ')';
        c.style.zIndex = String(10 - a); c.style.opacity = String(o); c.style.pointerEvents = a > 2 ? 'none' : 'auto';
        c.classList.toggle('is-active', off === 0);
      });
    }
    function go(k) { i = (k + n) % n; layout(); }
    function restart() { clearInterval(t); if (auto > 0) t = setInterval(function () { go(i + 1); }, auto * 1000); }
    on($('[data-odt-next]', root), 'click', function () { go(i + 1); restart(); });
    on($('[data-odt-prev]', root), 'click', function () { go(i - 1); restart(); });
    cards.forEach(function (c, k) { on(c, 'click', function (e) { if (k !== i) { e.preventDefault(); go(k); restart(); } }); });
    var x0 = null, moved = false;
    on(stage, 'pointerdown', function (e) { x0 = e.clientX; moved = false; });
    on(stage, 'pointermove', function (e) { if (x0 !== null && Math.abs(e.clientX - x0) > 8) moved = true; });
    on(stage, 'pointerup', function (e) { if (x0 === null) return; var dx = e.clientX - x0; x0 = null; if (Math.abs(dx) > 40) { go(dx < 0 ? i + 1 : i - 1); restart(); } });
    on(stage, 'click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    on(W, 'resize', layout); layout(); restart();
  }

  /* ---------- mozaik: oklar görselleri döndürür ---------- */
  function initMosaic(root) {
    if (root.__odt) return; root.__odt = 1;
    var imgs = $$('.odt-mosaic__tile--image img', root);
    function rot(dir) {
      var srcs = imgs.map(function (im) { return { s: im.getAttribute('src'), ss: im.getAttribute('srcset') || '', a: im.alt }; });
      if (srcs.length < 2) return;
      if (dir > 0) srcs.unshift(srcs.pop()); else srcs.push(srcs.shift());
      imgs.forEach(function (im, k) {
        im.style.transition = 'opacity .18s'; im.style.opacity = '0';
        setTimeout(function () { im.setAttribute('src', srcs[k].s); if (srcs[k].ss) im.setAttribute('srcset', srcs[k].ss); im.alt = srcs[k].a; im.style.opacity = ''; }, 180);
      });
    }
    $$('[data-odt-mosaic-next]', root).forEach(function (b) { on(b, 'click', function (e) { e.preventDefault(); rot(1); }); });
    $$('[data-odt-mosaic-prev]', root).forEach(function (b) { on(b, 'click', function (e) { e.preventDefault(); rot(-1); }); });
  }

  /* ---------- yorum şeridi (ürün sayfası): açıklamadaki .ty-reviews bloğundan kartlar üretir ---------- */
  function initReviews(root) {
    if (root.__odt) return; root.__odt = 1;
    var src = $('.ty-reviews'), img = root.getAttribute('data-image') || '', list = $('.odt-reviews__rows', root);
    if (!src || !list) { root.hidden = true; return; }
    var items = [];
    $$('div', src).forEach(function (d) {
      var p = $('p', d), spans = d.querySelectorAll('span');
      if (!p || !spans.length || !/★/.test(spans[0].textContent)) return;
      items.push({ stars: spans[0].textContent.trim(), date: spans[1] ? spans[1].textContent.trim() : '', text: p.textContent.trim() });
    });
    if (!items.length) { root.hidden = true; return; }
    items = items.slice(0, 24);
    var rows = [D.createElement('div'), D.createElement('div')];
    rows.forEach(function (r) { r.className = 'odt-reviews__row'; });
    items.forEach(function (it, k) {
      var c = D.createElement('article'); c.className = 'odt-review';
      c.innerHTML = (img ? '<div class="odt-review__img"><img src="' + img + '" alt="" loading="lazy"></div>' : '') +
        '<div class="odt-review__body"><div class="odt-review__name">Doğrulanmış Müşteri <span></span></div><div class="odt-review__stars"></div><p></p></div>';
      $('.odt-review__name span', c).textContent = it.date;
      $('.odt-review__stars', c).textContent = it.stars;
      $('p', c).textContent = it.text;
      rows[k % 2].appendChild(c);
    });
    list.innerHTML = ''; rows.forEach(function (r) { if (r.children.length) list.appendChild(r); });
    var sum = $('.mk-rsum', src), head = $('.odt-reviews__count', root);
    if (sum && head) head.textContent = Array.prototype.map.call(sum.children, function (c) { return c.textContent.replace(/\s+/g, ' ').trim(); }).filter(Boolean).join('  ·  ');
    on($('[data-odt-prev]', root), 'click', function () { rows.forEach(function (r) { r.scrollBy({ left: -r.clientWidth * 0.8, behavior: 'smooth' }); }); });
    on($('[data-odt-next]', root), 'click', function () { rows.forEach(function (r) { r.scrollBy({ left: r.clientWidth * 0.8, behavior: 'smooth' }); }); });
    root.hidden = false;
  }


  /* ---------- kareler (dikey video şeridi): görünürken sessiz oynat, tıklayınca sesli aç ---------- */
  function initReels(root) {
    if (root.__odt) return; root.__odt = 1;
    var vids = $$('video', root);
    if ('IntersectionObserver' in W) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { var v = e.target; if (e.isIntersecting) { if (!v.getAttribute('src')) v.setAttribute('src', v.getAttribute('data-src') || ''); var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); } else { try { v.pause(); } catch (x) {} } }); }, { threshold: 0.25 });
      vids.forEach(function (v) { io.observe(v); });
    } else { vids.forEach(function (v) { v.setAttribute('src', v.getAttribute('data-src') || ''); v.play().catch(function () {}); }); }
  }

  /* ---------- yukarı çık ---------- */
  function initScrollTop() {
    if ($('#odt-scroll-top')) return;
    var b = D.createElement('button'); b.id = 'odt-scroll-top'; b.type = 'button'; b.setAttribute('aria-label', 'Yukarı çık');
    b.innerHTML = '<svg viewBox="0 0 24 24"><path d="M12 19V5M5 12l7-7 7 7"/></svg>';
    D.body.appendChild(b);
    on(b, 'click', function () { W.scrollTo({ top: 0, behavior: 'smooth' }); });
    function sc() { b.classList.toggle('is-on', W.scrollY > 600); }
    on(W, 'scroll', sc, { passive: true }); sc();
  }

  function init(scope) {
    scope = scope || D;
    $$('.odt-header', scope).forEach(initHeader);
    $$('[data-odt-hero]', scope).forEach(initHero);
    $$('[data-odt-track]', scope).forEach(initTrack);
    $$('[data-odt-fan]', scope).forEach(initFan);
    $$('[data-odt-mosaic]', scope).forEach(initMosaic);
    $$('[data-odt-reviews]', scope).forEach(initReviews);
    $$('[data-odt-reels]', scope).forEach(initReels);
    initScrollTop();
  }
  if (D.readyState === 'loading') on(D, 'DOMContentLoaded', function () { init(); }); else init();
  on(D, 'shopify:section:load', function (e) { init(e.target); });
  W.ODT = W.ODT || {}; W.ODT.toast = toast; W.ODT.addToCart = addToCart; W.ODT.openVideo = openVideo; W.ODT.refreshCart = refreshCart;
})();
